module.exports = __webpack_public_path__ + "media/newstyle/images/slider-arrow-left-grey-8849992568ed345598a052d7d05b85b8.svg";